import React, { useCallback, useRef } from 'react';

import Bugsnag from '@bugsnag/js';

export const withFixedOnOpen = C => ({ onMenuClose: onMenuCloseProp, onMenuOpen: onMenuOpenProp, name, ...props }) => {
  const lastKnownMenuStateIsOpen = useRef(false);

  const onMenuOpen = useCallback(() => {
    if (lastKnownMenuStateIsOpen.current === false) {
      Bugsnag.leaveBreadcrumb('Open select menu', { name });
      onMenuOpenProp();
    }
    lastKnownMenuStateIsOpen.current = true;
  }, [onMenuOpenProp, name]);

  const onMenuClose = useCallback(() => {
    if (lastKnownMenuStateIsOpen.current === true) {
      onMenuCloseProp();
    }
    lastKnownMenuStateIsOpen.current = false;
  }, [onMenuCloseProp]);

  //intentionally don't pass name from props: select2 uses it on inputs and breaks tests.
  return <C onMenuOpen={onMenuOpen} onMenuClose={onMenuClose} {...props}/>;
};
